export default {"src":"/_next/static/media/GetAppSvg.778b85a4.svg","height":24,"width":117,"blurWidth":0,"blurHeight":0};